import React, { useState } from 'react';
import Img from 'gatsby-image/withIEPolyfill';
import { WebsiteImage } from 'components/TitleDescription';
import { CardContainer } from './styles';
import BlogCard from './CardsBody/BlogCard';
import StatCard from './CardsBody/StatCard';
import ReviewCard from './CardsBody/ReviewCard';
import IconCard from './CardsBody/IconCard';
import ComparisonCard from './CardsBody/ComparisonCard';
import WistiaVideo from 'components/Core/WistiaVideo';
import HyperLink from 'components/Core/HyperLink';

const Cards = props => {
  const {
    type,
    bodyType,
    category,
    tags,
    title,
    description,
    quote,
    author,
    company,
    companyLogo,
    percent,
    cta,
    ctaTitle,
    ctaLink,
    coverImage,
    coverVideo,
    coverOverlay,
    markIcon,
    topLeftIcon,
    iconType,
    iconImage,
    noShadow = false,
    align = 'left',
    coverBackColor = '#ffffff',
    bodyBackColor = '#ffffff',
    sideCover = false,
    sideReverse = false,
    simpleResponsive = false,
  } = props;
  const [hovered, setHovered] = useState(false);
  const CardBody =
    type === 'Icon'
      ? IconCard
      : bodyType === 'review'
      ? ReviewCard
      : bodyType === 'comparison'
      ? ComparisonCard
      : bodyType === 'blog' || bodyType === 'simple'
      ? BlogCard
      : bodyType === 'stat' || percent || author
      ? StatCard
      : BlogCard;

  return (
    <CardContainer
      data-testid="card-container"
      className={`card--container 
        ${noShadow ? ' no-shadow' : ''} 
        ${sideCover ? ' side-cover' : ''} 
        ${sideReverse ? ' side-reverse' : ''} 
        ${simpleResponsive ? ' simple-responsive' : ''}`}
      hovered={ctaLink && hovered}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
    >
      {topLeftIcon && (
        <div data-testid="top-left-icon" className="card--top-left-icon">
          <WebsiteImage src={topLeftIcon} />
        </div>
      )}

      {coverImage ? (
        <div
          data-testid="card-cover"
          className={`card--cover ${topLeftIcon ? 'has-top-left-icon' : ''}`}
        >
          <div className="card--cover-wrapper">
            {coverOverlay && (
              <div data-testid="card-overlay" className="card--cover-overlay">
                {coverOverlay}
              </div>
            )}
            <Img
              className="card--cover-image"
              fluid={coverImage.fluid || coverImage.image?.fluid || coverImage}
              alt={coverImage.alt || coverImage.title}
            />
            {markIcon && (
              <div data-testid="card-mark-icon" className="card--cover-mark-icon">
                <WebsiteImage src={markIcon} />
              </div>
            )}
          </div>
        </div>
      ) : coverVideo ? (
        <div
          data-testid="card-cover"
          className={`card--cover ${topLeftIcon ? 'has-top-left-icon' : ''}`}
        >
          <div className="card--cover-wrapper">
            <WistiaVideo
              data-testid="card-cover-video"
              className="card--cover-video"
              url={coverVideo}
            />
          </div>
        </div>
      ) : null}

      {CardBody && (
        <div
          data-testid="card-body"
          className={`card--body ${topLeftIcon ? 'has-top-left-icon' : ''}`}
        >
          <CardBody hovered={hovered} {...props} />
        </div>
      )}

      {ctaLink && (
        <HyperLink
          data-testid="card-link"
          data-position="Body - Card CTA1"
          className="card--link"
          state={{ tags }}
          href={ctaLink}
        />
      )}
    </CardContainer>
  );
};

export default Cards;
